/** Direct Shopify cart links for each pack. */
export const CHECKOUT_BASE = 'https://www.nuevonivel.shop/cart/50105937854704:1'
export const CHECKOUT_PRO = 'https://www.nuevonivel.shop/cart/50105938149616:1'
